import React from 'react';
import { useAuth } from '../../context/AuthContext';
import { FiUser } from 'react-icons/fi';

const Header = ({ title }) => {
  const { user } = useAuth();

  // Helper function to create a simple avatar with the user's initials
  const getInitials = (name = '') => {
    const names = name.split(' ');
    // Handle cases with more than one name part
    if (names.length > 1) {
      return `${names[0][0]}${names[names.length - 1][0]}`.toUpperCase();
    }
    // Handle single-word names
    return name.substring(0, 2).toUpperCase();
  };

  return (
    <header className="bg-white shadow-sm p-4 flex justify-between items-center sticky top-0 z-10">
      {/* Page Title */}
      <h1 className="text-2xl font-bold text-gray-800">{title}</h1>

      {/* User Profile Display */}
      <div className="flex items-center">
        <div className="text-right mr-4">
          <p className="font-semibold text-gray-800">{user?.name}</p>
          {/* Safely map over roles, which is an array of objects */}
          <p className="text-xs text-gray-500">{user?.roles?.map(r => r.name).join(', ')}</p>
        </div>
        <div className="w-10 h-10 rounded-full bg-primary text-white flex items-center justify-center font-bold text-sm">
          {user ? getInitials(user.name) : <FiUser />}
        </div>
      </div>
    </header>
  );
};

export default Header;